
export const EMAIL_TYPE = [
  {
    label: 'imap',
    value: 'imap',
  },
  {
    label: 'smtp',
    value: 'smtp',
  },
]
export const PROTOCOL = [
  {
    label: 'default',
    value: 'default',
  },
  {
    label: 'SSL',
    value: 'SSL',
  },
]

export const ORDER_STATUS = {
  0: '待支付', 1: '进行中', 2: '待签收', 3: '已妥投', 4: '已完成', 5: '部分发货', 6: '售后中', 7: '已取消'
}

export let ORDER_STATUS_LIST = Object.keys(ORDER_STATUS).map(item => {
  return {
    label: ORDER_STATUS[item],
    value: item
  }
})

export const SALES_STATUS = {
  0: '无售后', 1: '售后处理中', 2: '售后已完成', 3: '售后异常', 4: '售后已取消'
}
export const FULFILMENTSTATUS = {
  0: '待处理', 1: '待发货', 2: '部分发货', 3: '已发货', 4: '已上网', 5: '部分签收', 6: '已签收', 7: '退货中',
}
export let FULFILMENTSTATUS_LIST = Object.keys(FULFILMENTSTATUS).map(item => {
  return {
    label: FULFILMENTSTATUS[item],
    value: item
  }
})
export const PAY_TYPE = {
  0: '未支付', 1: 'PayPal', 2: 'Stripe', 3: 'WorldPay', 4: 'AsiaBill', 5: 'OceanPayment', 6: 'PacyPay', 7: 'PingPongPay', 8: 'UseePay', 9: 'bogus', 10: 'manual', 99: '其他'
}
export const PAY_STATUS = {
  0: '待支付', 1: '已支付', 2: '支付失败', 3: '已取消', 4: '待退款', 5: '部分退款', 6: '已退款', 7: '退款失败'
}
export let STATUS_OPTION = [
  { label: '全部状态', value: '' },
  { label: '待开始', value: 1 },
  { label: '进行中', value: 2 },
  { label: ' 已禁用', value: 4 },
  { label: ' 已结束', value: 3 },
  { label: '已删除', value: 5 }
]

export const PLATFORM = {
  1: 'Shoplus', 2: 'Shopify', 3: '店匠', 4: 'Shopline', 5: 'Shopbase'
}
export let PLATFORM_LIST = Object.keys(PLATFORM).map(item => {
  return {
    label: PLATFORM[item],
    value: Number(item)
  }
})
export let TREND_LIST = [
  { label: 'CPC', value: 'cpc' },
  { label: 'CPM', value: 'cpm' },
  { label: '展示量', value: 'show_num' },
  { label: '点击量', value: 'landing_page_view_num' },
  { label: '加购量', value: 'add_purchase_num' },
  { label: '发起结账量', value: 'payment_num' },
  { label: '下单量', value: 'order_num' },
  { label: '点击率', value: 'click_rate' },
  { label: '浏览率', value: 'visit_rate' },
  { label: '加购率', value: 'add_purchase_rate' },
  { label: '发起结算率', value: 'payment_rate' },
  { label: '广告转化率', value: 'trans_rate' },
]
export const PRUCHASE_STATUS = {
  1: '待审核', 2: '已审核', 3: '已复核', 4: '部分到货', 5: '全部到货', 6: '已完成', 7: '已关闭'
}
export const changeLanguage = () => {
  EMAIL_TYPE.map(item => window.$t(`system::email_type::${item.label}`))
  PROTOCOL.map(item => window.$t(`system::protocol:::${item.label}`))
  for (const [key, value] of Object.entries(ORDER_STATUS)) {
    ORDER_STATUS[key] = window.$t(`system::order_status::${value}`)
  }
  for (const [key, value] of Object.entries(SALES_STATUS)) {
    SALES_STATUS[key] = window.$t(`system::sale_status::${value}`)
  }
  for (const [key, value] of Object.entries(FULFILMENTSTATUS)) {
    FULFILMENTSTATUS[key] = window.$t(`system::fulfilmentstatus::${value}`)
  }
  for (const [key, value] of Object.entries(PAY_TYPE)) {
    PAY_TYPE[key] = window.$t(`system::pay_type::${value}`)
  }
  for (const [key, value] of Object.entries(PAY_STATUS)) {
    PAY_STATUS[key] = window.$t(`system::pay_status::${value}`)
  }
  for (const [key, value] of Object.entries(PLATFORM)) {
    PLATFORM[key] = window.$t(`system::platform::${value}`)
  }
  PLATFORM_LIST.map(item => {
    return { ...item, label: window.$t(`system::platform::${item.label}`) }
  })
  TREND_LIST = TREND_LIST.map(item => {
    return { ...item, label: window.$t(`system::trend::${item.label}`) }
  })
  STATUS_OPTION = STATUS_OPTION.map(item => {
    return { ...item, label: window.$t(`system::status_option::${item.label}`) }
  })
  ORDER_STATUS_LIST = ORDER_STATUS_LIST.map(item => {
    return { ...item, label: window.$t(`system::order_status::${item.label}`) }
  })
  FULFILMENTSTATUS_LIST = FULFILMENTSTATUS_LIST.map(item => {
    return { ...item, label: window.$t(`system::fulfilmentstatus::${item.label}`) }
  })
  for (const [key, value] of Object.entries(PRUCHASE_STATUS)) {
    PRUCHASE_STATUS[key] = window.$t(`system::purchase::status::${value}`)
  }
}
